import React from "react";
import { Link } from "react-router-dom";
import { MapPinIcon, EnvelopeIcon } from "@heroicons/react/24/solid"; // Importing icons

const Footer = () => {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-3 bg-[#2b2727] h-auto md:h-[390px] text-white">
        <div className="mt-4 md:mt-16 p-4 md:p-0 md:ml-16">
          <div className="pb-4 text-xl">About Donate Great</div>
          <div className="pb-4 text-3xl flex">
            <img
              className="h-8 w-8 mr-4"
              src="https://d1irs7zslorh1g.cloudfront.net/logo.png"
              alt="Favicon"
            />
            <h1>Donate Great</h1>
          </div>
          <div>
            Every small action ignites a spark of change, creating ripples that
            extend far beyond the initial splash. By choosing kindness,
            compassion, and understanding, we can transform our world, one deed
            at a time.
          </div>
        </div>
        <div className="mt-4 md:mt-16 p-4 md:p-0 md:ml-12">
          <div className="pl-0">
            <div className="text-xl pb-4">Blogroll</div>
            <ul className="list-none m-0 p-0">
              <li className="relative border-b border-[#5c5b5b] w-80 pl-5 py-4">
                Become a volunteer
              </li>
              <li className="relative border-b border-[#5c5b5b] w-80 pl-5 py-4">
                Our mission
              </li>
              <li className="relative border-b border-[#5c5b5b] w-80 pl-5 py-4">
                Success Stories
              </li>
              <li className="relative border-b border-[#5c5b5b] w-80 pl-5 py-4">
                Meet our team
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-4 md:mt-16 p-4 md:p-0">
          <div className="pb-4 text-xl">Contact Us</div>
          <div className="flex items-center pb-2">
            <MapPinIcon className="h-6 w-6 text-blue-400 mr-2" />
            <span>6th Floor, WeWork Futura, Magarpatta Rd, Hadapsar, Pune, 411028</span>
          </div>
          <div className="flex items-center">
            <EnvelopeIcon className="h-6 w-6 text-blue-400 mr-2" />
            <a href="mailto:info@donategreat.com" className="text-blue-400">info@donategreat.com</a>
          </div>
        </div>
      </div>
      <div className="bg-black flex justify-between text-white h-16 p-4">
        <div>&#169; 2024 All rights reserved</div>
        <Link to="/terms-and-conditions">
          <div className="flex gap-4">
            <p>Privacy Policy /</p>
            <p>Payment terms /</p>
            <p>Refund Policy</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Footer;
